export default "__VITE_ASSET__BLisgq42__"